import { IQuiz } from '../IQuiz'

export const dipPatterns4: IQuiz = {
  name: 'dip-patterns-4',
  question: 'В чём заключается суть шаблонного метода?',
  variants: [
    {
      text: 'Описывает алгоритм, который будет реализован позже потомками сущности'
    },
    {
      text: 'Определяет скелет алгоритма, некоторые шаги которого могут быть реализованы потомками сущности'
    },
    {
      text: 'Определяет скелет алгоритма для каждого потомка сущности, которые потом будут его реализовывать'
    }
  ],
  meta: {
    correctAnswers: [1]
  }
}
